module.exports = __webpack_public_path__ + "img/7.e40c6f0f.jpg";